import { render, staticRenderFns } from "./MenuPanel.vue?vue&type=template&id=6f61b107&"
import script from "./MenuPanel.vue?vue&type=script&lang=js&"
export * from "./MenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports